import { Injectable } from '@angular/core'

import { Observable } from 'rxjs/Observable'
import { Observer } from 'rxjs/Observer'

import { MapsAPILoader } from '@agm/core'
import { environment } from '../../environments/environment'

import * as firebase from 'firebase'
import * as GeoFire from 'geofire'

@Injectable()
export class GeolocationService {

  constructor(private mapsAPILoader: MapsAPILoader) { }

  public getCurrentPosition(opts?: PositionOptions): Observable<Position> {
    return Observable.create((observer: Observer<any>) => {
      if (window.navigator && window.navigator.geolocation) {
        window.navigator.geolocation.getCurrentPosition(
          (position: Position) => {
            observer.next(position)
            observer.complete()
          },
          (error: PositionError) => {
            console.error('Geolocation service : ' + error.message)
            observer.error(error.message)
          },
          opts
        )
      } else {
        observer.error('Browser does not support location services')
      }
    })
  }

  public getFormattedAddress(lat: number, lng: number): Observable<string> {
    return Observable.fromPromise(this.mapsAPILoader.load())
      .mergeMap(() => {
        const geocoder = new google.maps.Geocoder()
        const latlng = new google.maps.LatLng(lat, lng)

        return Observable.create((observer: Observer<string>) => {
          geocoder.geocode({location: latlng}, (results, status) => {
            if (status === google.maps.GeocoderStatus.OK) {
              for (let i = 0 ; i < results.length ; i++) {
                const index = results[i].types.indexOf('locality')
                if (index > -1) {
                  const location = results[i].formatted_address
                  observer.next(location)
                  break
                }
              }
            } else {
              observer.error('Geocoder error : ' + status)
            }
          })
        })
      })
  }

}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/geolocation/geolocation.service.ts